import React, {useState, useEffect} from "react";
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {Box, Button, FormControl, List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';
import {Circle, ExpandLessRounded, ExpandMoreRounded} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import ButtonComponent from '../components/ButtonComponent';
import CircularProgressLoader from '../components/CircularProgressLoader';
import {BUTTON_PRIMARY, BUTTON_WARNING, SUCCESS, ERROR, TOAST_ERROR} from '../assets/constants/Constants';
import {LoptopIcon, LuggageIcon, OfficeBegIcon, RADIO_CHECKED_ICON, RADIO_UNCHECKED_ICON, SchoolBegIcon, bestIcpon} from '../assets/constants/Icons';
import {LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION, LOGIN, OPEN_LOCKER, PARCEL_OWNER} from '../assets/constants/PageList';
import {LOCAL_STORAGE, SESSION_STORAGE, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, SS_PAYMENT_GATEWAY, SS_PAYMENT_GATEWAY_ACCESS_KEY, PAYMENT_REFERENCE_ID, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, LS_PROP_LOCKER_UNIT_DETAILS, IS_LOGGED_IN, LS_DOMAIN_AND_LOCKER_BANK} from '../assets/constants/BrowserStorageKeys';
import {getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage} from '../lib/BrowserStorageAccessMiddleware';
import {getTenantAndAssignmentSettings, reserveLocker} from '../api/api';
import {prePaymentRegistration} from '../lib/BackendUtils';
import {getPathForNextPage, convertDurationStringToMilliseconds, verifyUserProximity, toFeetInches, checkIfAssignmentIsProperlyConfigured, applyBackendLanguageConfig, getPriceBySizeFor24Hr, formatPrice, getPriceFor24Hr} from '../lib/Utils';
import CustomDialog from '../components/CustomDialog';
import ShowToast from '../components/ToastComponent';
import { ReactComponent as DuroltLogoIcon } from "../assets/images/durolt_logo_new.svg";
import LockerIcon from '../assets/locker.svg';
import BookingSummary from "../components/BookingSummary";
import LockerDurationDialog from "../components/LockerDurationDialog";
import LockerBooking from "../components/LockerBookingSlotComponent";
import LockerModalContent from "../components/LockerBookingSlotComponent";

const LockerSizePage = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('Loading'));
    const [showBookingConfirmationModal, setBookingConfirmationModalVisibility] = useState(false);
    const { lockerBankId, assignmentSlug, userId, availableLockerSizes, isManualLockerSelectionEnabled, IsAdvanceBooking = false, address="puna lulla nagar" , 
        bookingTimingObject=[{}] , locker_bank_slug
     } = history.location?.state;
    const isPricingEnabled = tenantAndAssignmentSettings?.is_pricing;
    const isParcelDropUser = tenantAndAssignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value;
    const [selectedSizeId, setSelectedSizeId] = useState(null);
    const [selectedSlotId, setSelectedSlotId] = useState(null);
    const [showBookingSlots, setShowBookingSlots] = useState(false);
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    const [showBookingInstructionModal, setShowBookingInstructionModal] = useState(isPricingEnabled);
    const [lockerQty, setLockerQty] = useState({});
    const [selectedLockers, setSelectedLockers] = useState([]);
    const [showSummaryDetails, setShowSummaryDetails] = useState(false);
    const[showSlotDurationDailog, setShowSlotDurationDailog] = useState(false);
   // const [selectedBookingSlot, setSelectedBookingSlot] = useState([]);
const [selectedBookingSlot, setSelectedBookingSlot] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    console.log("availableLockerSizes in locker size page :",availableLockerSizes , 
        " IsAdvanceBooking: ", IsAdvanceBooking , " bookingTimingObject: ",bookingTimingObject);
        console.log("availableLockerSizes : ", availableLockerSizes);
        
    useEffect(() => {
        if (isPricingEnabled && !IsAdvanceBooking ) {
            sortAndFormatSlotDuration();
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        console.log("showSlotDurationDailog updated:", showSlotDurationDailog);
    }, [showSlotDurationDailog]);

    const increaseQty = (locker, price24h) => {
    if (!IsAdvanceBooking && locker?.bookingSlots) {
        setSelectedBookingSlot(locker.bookingSlots);
        setShowSlotDurationDailog(true);
    }

    setSelectedLockers((prev) => {
        const count = prev.filter(
        (item) => item.door_size === locker.code
        ).length;

        if (count >= locker.available_doors_count) return prev;

        return [
        ...prev,
        {
            door_size: locker.code,
            price: IsAdvanceBooking ? price24h : 0,
            durations: [
            {
                label: "24 hours",
                price: IsAdvanceBooking ? price24h : 0,
            },
            ],
            name: `${locker.name} Locker`,
        },
        ];
    });
    };

    const decreaseQty = (locker) => {
    if (!IsAdvanceBooking && locker?.bookingSlots) {
        setSelectedBookingSlot(locker.bookingSlots);
        setShowSlotDurationDailog(true);
    }

    setSelectedLockers((prev) => {
        const index = prev.findIndex(
        (item) => item.door_size === locker.code
        );

        if (index === -1) return prev;

        const newArray = [...prev];
        newArray.splice(index, 1);

        return newArray;
    });
    };
    
    const getSettingsValidateAndRedirectUser = async (lockerBankId, bookingObject) => {
        console.log(" calling with bookingObject is: ", bookingObject);
            try {
                const response = await getTenantAndAssignmentSettings(lockerBankId);
                applyBackendLanguageConfig(response);
    
                if (response.status === SUCCESS) {
                    if (response?.data?.locker_assignments.length > 1) {
                        history.push({
                            pathname: '/assignments',
                            state: {
                                tenantAndAssignmentSettings: response?.data
                            }
                        });
                    }
                    else if (response?.data?.locker_assignments.length === 1) {
                        const isAssignmentProperlyConfigured = await checkIfAssignmentIsProperlyConfigured(response?.data);
                        
                        if (isAssignmentProperlyConfigured === true) {
                            console.log("isAssignmentProperlyConfigured :", isAssignmentProperlyConfigured);
                            const redirectionPath = getPathForNextPage(LOCKER_SIZE_SELECTION, LOGIN);
                            console.log("redirectionPath: ", redirectionPath);
                            history.push({
                                pathname: redirectionPath,
                                state: {
                                   bookingObject: bookingObject
                                }
                            });
                                console.log("status:", response.status);
                                console.log("assignments:", response?.data?.locker_assignments?.length);
                                console.log("isAssignmentProperlyConfigured:", isAssignmentProperlyConfigured);
                                console.log("LS_DOMAIN_AND_LOCKER_BANK:", getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK));
                                console.log("IS_LOGGED_IN:", getSecureItemFromSpecificStorage(LOCAL_STORAGE, IS_LOGGED_IN));
                        }
                        else {
                            // resetInputValue();
                            // setDialogContentText( t(isAssignmentProperlyConfigured?.errorMessage) );
                            // setDialogVisible(true);
                            // handle the error 
                            console.log("error ")
                        }
                    }
                    else {
                        // resetInputValue();
                        // setDialogContentText( t('noLockerAssignments') );
                        // setDialogVisible(true);
                        // handle the error 
                         console.log("error ")
                    }
                }
            } catch (error) {
                // resetInputValue();
                // setDisabled(true);
                // handle the error 
                 console.log("error ")
                console.error('Error while getting settings and validation: ', error);
            }
        }


const totalPrice = selectedLockers.reduce((sum, locker) => {
    return sum + locker.price;
}, 0);

const handleLockerBooking = async()=>{
    // create payload object for reserver the locker
    console.log("selected locker is : ", selectedLockers);

    // Transform selectedLockers into allocation_data format
    const allocationData = selectedLockers.map(locker => ({
        door_size: locker.door_size,
        price: locker.price
    }));
    
    const bookingObject = {
        ...bookingTimingObject,
        allocation_method : IsAdvanceBooking ? "automatic_allocation" : "normal",
        allocation_data: allocationData,
        total_price:totalPrice,
        locker_bank_id: lockerBankId,
        locker_bank_slug:locker_bank_slug,
        assignmentSlug:assignmentSlug
    }
    console.log("handleLockerBooking object : ", bookingObject);

    // now if it is advance booking then redirect to login page else make payment process 
    if(IsAdvanceBooking){
        // redirect to login page before redirect to login page set the valid assignment setting to application 
        // so user can login and process further 
         history.push({
                    pathname: '/login-page',
                    state: {
                        bookingObject: bookingObject
                    }
                });
    }else{
        // make payment process as normal flow
    }

}

    console.log("lockerBankId: ", lockerBankId , "assignmentSlug: ", assignmentSlug , "userId: ", userId , "availableLockerSizes: ",availableLockerSizes,
        "isManualLockerSelectionEnabled: ", isManualLockerSelectionEnabled ,  "IsAdvanceBooking: ",IsAdvanceBooking);
    // avaid this below funtion for advance booking
    const sortAndFormatSlotDuration = () => {
        availableLockerSizes.forEach((lockerSize) => {
            lockerSize.dimensions = `${parseFloat(lockerSize.width)}\" x ${parseFloat(lockerSize.length)}\" x ${parseFloat(lockerSize.height)}\"`;

            lockerSize.size_pricing.forEach((slot) => {
                slot.durationInMilliseconds = convertDurationStringToMilliseconds(slot.duration);
            });

            const incrementallySortedBookingSlots = sortBookingSlotsBasedOnDuration(lockerSize.size_pricing);

            let previousDurationInMilliseconds = 0;
            incrementallySortedBookingSlots.forEach((slot) => {
                slot.durationRange = `${previousDurationInMilliseconds / 3600000} - ${slot.durationInMilliseconds / 3600000} Hours`;
                previousDurationInMilliseconds = slot.durationInMilliseconds;
            });

            lockerSize.bookingSlots = incrementallySortedBookingSlots;
        });
    };
    // avaid this below funtion for advance booking
    const sortBookingSlotsBasedOnDuration = (slotsArray) => {
        return slotsArray.slice().sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
    };

    const lockerSizeClickHandler = (item) => {
        if (isPricingEnabled) {
            setSelectedSizeId(item.id);
            setSelectedSlotId(item.bookingSlots[0].id);
            setShowBookingSlots(true);
        }
        else if (isParcelDropUser) {
            history.replace({
                pathname:getPathForNextPage(LOCKER_SIZE_SELECTION, PARCEL_OWNER),
                state: {
                    lockerSize: item.code,
                    lockerItem:item,
                }
            })            
        }
        else {
            lockerSizeSelectionHandler(item);
        }
    }

    
     // avaid this below funtion for advance booking
    const lockerSizeSelectionHandler = async (item) => {
        if (isManualLockerSelectionEnabled) {
            history.replace({
                pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION),
                state: {
                    lockerBankId,
                    assignmentSlug,
                    userId,
                    selectedLockerSize: item
                }
            });
        }
        else {
            setIsLoading(true);
            try {
                if (tenantAndAssignmentSettings?.is_geofencing) {
                    const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
                    const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
                    const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
                    const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
                    
                    if ( !isUserNearbyLockerBank.isNearby ) {
                        setLoadingMessage('');
                        setIsLoading(false);
                        setUserProximityError(isUserNearbyLockerBank.message);
                        setIsUserProximityErrorModalVisible(true);
        
                        return;
                    }
                }

                const reserveLockerResponse = await reserveLocker(assignmentSlug, lockerBankId, userId, item.code);
                if (reserveLockerResponse.status === SUCCESS) {
                    const lockerUnitDetails = {
                        ref_id: reserveLockerResponse?.data?.transaction_id,
                        is_already_opened_once: false,
                        locker_bank: {
                            name: reserveLockerResponse?.data?.locker_bank_name
                        },
                        locker_door: {
                            door_no: reserveLockerResponse?.data?.door_no
                        }
                    };

                    history.replace({
                        pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, OPEN_LOCKER),
                        state: {
                            lockerUnitDetails
                            // assignedLocker: response.data
                        }
                    });
                }
            } catch (error) {
                setIsLoading(false);
                console.error('Error while reserving locker: ', error);
            }
        }
    };

    // should for advance booking
    const bookButtonHandler = async () => {
        setLoadingMessage(t('initiating_transaction_please_wait'));
        setIsLoading(true);

        if (tenantAndAssignmentSettings?.is_geofencing) {
            const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
            const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
            const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
            const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
            
            if ( !isUserNearbyLockerBank.isNearby ) {
                setLoadingMessage('');
                setIsLoading(false);
                setUserProximityError(isUserNearbyLockerBank.message);
                setIsUserProximityErrorModalVisible(true);

                return;
            }
        }

        const selectedSize = availableLockerSizes.filter((lockerSize) => selectedSizeId === lockerSize?.id)[0];
        const selectedSlot = selectedSize?.size_pricing.filter((slot) => selectedSlotId === slot?.id)[0];

        const reserveLockerResponse = await reserveLockerTillSuccessfulPayment(selectedSize, selectedSlot);
        
        if (reserveLockerResponse?.status === SUCCESS) {
            const prePaymentResponse = await makePrePaymentRegistration(reserveLockerResponse.data);
            console.log('pre payment response: ', prePaymentResponse);

            if (prePaymentResponse?.status === SUCCESS) {
                // if (prePaymentResponse?.data?.data?.payment_gateway === 'stripe') {
                //     storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, 'isRedirectedFromStripePG', true);
                //     storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, PAYMENT_REFERENCE_ID, reserveLockerResponse?.data?.transaction_payments[0]?.transaction_id);

                //     window.location.href = prePaymentResponse?.data?.data?.field_1;
                // }

                const lockerUnitDetails = {
                    ref_id: reserveLockerResponse?.data?.transaction_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name
                    },
                    locker_door: {
                        door_no: reserveLockerResponse?.data?.door_no
                    }
                };

                if (prePaymentResponse?.data?.data?.payment_gateway === 'stripe') {
                    lockerUnitDetails.payment_records = [
                        {
                            payment_gateway: prePaymentResponse?.data?.data?.payment_gateway,
                            payment_gateway_reference: prePaymentResponse?.data?.data?.payment_id,
                            transaction_id: prePaymentResponse?.data?.data?.transaction_id
                        }
                    ];
                    console.log('locker unit details: ', lockerUnitDetails);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, true);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PROP_LOCKER_UNIT_DETAILS, lockerUnitDetails);

                    window.location.href = prePaymentResponse?.data?.data?.field_1;
                    return;
                }

                const lockerData = {
                    reservedLocker: reserveLockerResponse?.data,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name,
                        location: {
                            name: reserveLockerResponse?.data?.locker_bank_location
                        }
                    },
                    assignment: {
                        payment_gateway: [ reserveLockerResponse?.data?.assignment_payment_gateway ]
                    },
                    payment_records: [
                        { amount: prePaymentResponse?.data?.data?.amount }
                    ],
                    user: {
                        username: reserveLockerResponse?.data?.username ? reserveLockerResponse?.data?.username : "",
                        email: reserveLockerResponse?.data?.transaction_payments[0]?.user_email ? reserveLockerResponse?.data?.transaction_payments[0].user_email : "",
                        mobile_number: reserveLockerResponse?.data?.transaction_payments[0]?.user_mobile ? reserveLockerResponse?.data?.transaction_payments[0].user_mobile : ""
                    }
                };
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, prePaymentResponse?.data?.data?.payment_gateway);
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, prePaymentResponse?.data?.data?.payment_gateway_reference);

                setIsLoading(false);
                // return;

                history.replace({
                    pathname: '/payment-details',
                    state: {
                        lockerUnitDetails,
                        isLockerReservedTillSuccessfulPayment: true,
                        lockerData,
                        // paymentGateway: prePaymentResponse?.data?.data?.payment_gateway,
                        currentReferenceId: prePaymentResponse?.data?.data?.transaction_id,
                        // paymentGatewayAccessKey: prePaymentResponse?.data?.data?.payment_gateway_reference
                    }
                });
            }
            else if (prePaymentResponse.status === ERROR) {
                ShowToast(t(prePaymentResponse.message), TOAST_ERROR);
            }
        }

        setIsLoading(false);
    };

    const reserveLockerTillSuccessfulPayment = async (selectedSize, selectedSlot) => {
        try {
            return await reserveLocker(assignmentSlug, lockerBankId, userId, selectedSize?.code, null, selectedSlot?.id, parseFloat(selectedSlot?.price));
        } catch (error) {
            console.error('Error while reserving locker before payment: ', error);
        }
    };

    // should for advance booking
    const makePrePaymentRegistration = async (lockerData) => {
        try {
            const body = {
                "payment_reference_id": lockerData?.transaction_payments[0]?.transaction_id,
                "payment_gateway": lockerData?.transaction_payments[0]?.payment_gateway,
                "locker_bank_id": lockerBankId,
                "locker_door_number": lockerData?.door_no,
                "amount": lockerData?.transaction_payments[0]?.amount,
                "currency": lockerData?.transaction_payments[0]?.currency,
                "payment_mode": lockerData?.transaction_payments[0]?.payment_mode
            };

            if (lockerData?.transaction_payments[0]?.payment_gateway === 'stripe') {
                body.success_url = `${window.location.protocol}//${window.location.host}/swipe-to-open`;
                body.cancel_url = `${window.location.protocol}//${window.location.host}/home-screen`;
            }

            return await prePaymentRegistration(body);
        } catch (error) {
            console.error('Error while initating payment: ', error);
        }
    };

    //  should for avoid advance booking
    const renderBookingConfirmationModalContent = () => {
        const selectedSize = availableLockerSizes.filter((lockerSize) => selectedSizeId === lockerSize?.id)[0];
        const selectedSlot = selectedSize?.bookingSlots.filter((slot) => selectedSlotId === slot?.id)[0];
        const bookingStartDateAndTime = moment().format('DD MMM YYYY, hh:mm A');
        const bookingEndDateAndTime = moment().add(selectedSlot?.durationInMilliseconds, 'milliseconds').format('DD MMM YYYY, hh:mm A');

        return (
            <Box className='modal-content'>
                <Box className='booking-details'>
                    <Box className='info-row'>
                        <Typography className='left-column'>Slot:</Typography>
                        <Typography className='right-column'>{selectedSlot?.durationRange}</Typography>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('Start date & time:')}</Typography>
                        <Box>
                            <Typography className='right-column'>{bookingStartDateAndTime.split(',')[1]}</Typography>
                            <Typography className='right-column'>{bookingStartDateAndTime.split(',')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('End date & time:')}</Typography>
                        <Box>
                            <Typography className='right-column'>{bookingEndDateAndTime.split(',')[1]}</Typography>
                            <Typography className='right-column'>{bookingEndDateAndTime.split(',')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{`Price (${selectedSize?.currency}):`}</Typography>
                        <Typography className='right-column'>{selectedSlot?.price}</Typography>
                    </Box>
                </Box>
            </Box>
        );
    };

    const renderBookingInstructionsModalContent = () => {
        return (
            <div className="booking-instructions">
                <ol className="instructions-list list-decimal">
                    <li>{t('luggageLockerInstructionsPoint1')}</li>
                    <li>{t('luggageLockerInstructionsPoint2')}</li>
                    <li>{t('luggageLockerInstructionsPoint3')}</li>
                    <li>{t('luggageLockerInstructionsPoint4')}</li>
                    <li>{t('luggageLockerInstructionsPoint5')}</li>
                    <li>{t('luggageLockerInstructionsPoint6')}</li>
                    <li>{t('luggageLockerInstructionsPoint7')}</li>
                </ol>
            </div>
        );
    }
    const convertTOInch = (widths,depths, heights)=>{
        const width = toFeetInches(widths);
        const depth = toFeetInches(depths);
        const height = toFeetInches(heights);
        const finalDim = `${width} W x ${depth} D x ${height} H`;
        return finalDim;
    }

    const handleSelectedLokcerObject = ()=>{
            console.log("selectedLockers:", selectedLockers);
            setShowSummaryDetails(true);
            // creating object for modifying 

    }

    const HandleLockerSelection = () =>{
        console.log("HandleLockerSelection clicked")
        setShowSummaryDetails(false);
    }

    const handleLockerSelectionForSlot = (locker)=>{
        console.log("selected locker data is: ", locker);
        // setSelectedBookingSlot((prev) => [...prev, locker]);
         setSelectedBookingSlot(locker);
        setIsModalOpen(true)
    }

//     const LockerModalContent = () => {
//     return (
//         <div className="locker-modal">

//         {/* Locker Info */}
//         {/* Duration */}
//         <p className="slot-title">Choose duration slots of the booking</p>

//         <div className="slot active">
//             <input type="radio" checked />
//             <span>0–3 hrs</span>
//             <span>INR 60</span>
//         </div>

//         <div className="slot">
//             <input type="radio" />
//             <span>3–6 hrs</span>
//             <span>INR 120</span>
//         </div>

//         <div className="slot">
//             <input type="radio" />
//             <span>6–9 hrs</span>
//             <span>INR 180</span>
//         </div>

//         {/* Total */}
//         <div className="total-cost">
//             <span>Total Cost (INR)</span>
//             <span className="amount">60</span>
//         </div>
//         </div>
//     );
// };

    return (
        // <Box className='locker-size-page'>
        //     { ! IsAdvanceBooking ?
        //     <Box className='main-container'>
        //         {isLoading && (
        //             <Box className='main'>
        //                 <CircularProgressLoader message={loadingMessage} />
        //             </Box>
        //         )}
        //         {(!isLoading) && (
        //             <Box className='main'>
        //                 <Box className='locker-size-list'>
        //                     {availableLockerSizes.map((item, index) => (
        //                         <Box className='locker-size accordion' key={index}>
        //                             <Button className='accordion-header' onClick={() => lockerSizeClickHandler(item)}>
        //                                 <Typography className='size-name'>{item.name}</Typography>
        //                                 <Typography className='units-available'>({item.available_doors_count} {t('Available_Text')})</Typography>
        //                                 <Typography className='size-name'>({convertTOInch(item.width, item.depth, item.height)})</Typography>
        //                                 {(isPricingEnabled) && (
        //                                     <Box className='icon-container'>
        //                                         {(selectedSizeId === item.id) ? (
        //                                             <ExpandLessRounded className='accordion-icon' />
        //                                         ) : (
        //                                             <ExpandMoreRounded className='accordion-icon' />
        //                                         )}
        //                                     </Box>
        //                                 )}
        //                             </Button>
        //                             {(isPricingEnabled && showBookingSlots && (selectedSizeId === item.id)) && (
        //                                 <Box className='booking-slot-table accordion-details'>
        //                                     {/* <Typography className='heading'>Select slot</Typography> */}
        //                                     <Box className='table-header-row'>
        //                                         {/* <Box></Box> */}
        //                                         <Typography className='duration-heading'>Duration</Typography>
        //                                         <Typography className='price-heading'>Price ({item?.currency})</Typography>
        //                                     </Box>
        //                                     {item?.bookingSlots.map((bookingSlot, index) => (
        //                                         <Box key={index} className={`table-info-row booking-slot ${(selectedSlotId === bookingSlot?.id) && 'selected'}`} onClick={() => setSelectedSlotId(bookingSlot?.id)}>
        //                                             <Box className='icon-and-duration'>
        //                                                 <Box className='radio-icon'>
        //                                                     {(selectedSlotId === bookingSlot?.id) ? (
        //                                                         <RADIO_CHECKED_ICON />
        //                                                     ) : (
        //                                                         <RADIO_UNCHECKED_ICON />
        //                                                     )}
        //                                                 </Box>
        //                                                 <Typography className='slot-duration'>{bookingSlot?.durationRange}</Typography>
        //                                             </Box>
        //                                             {/* <Typography>{bookingSlot?.duration}</Typography> */}
        //                                             <Typography className='slot-price'>{bookingSlot?.price}</Typography>
        //                                         </Box>
        //                                     ))}
        //                                 </Box>
        //                             )}
        //                         </Box>
        //                     ))}
        //                 </Box>
        //                 {isPricingEnabled && (
        //                     <>
        //                         <Box className='book-button-container'>
        //                             <ButtonComponent
        //                                 buttonId='book-button'
        //                                 handleClick={() => setBookingConfirmationModalVisibility(true)}
        //                                 disabled={(selectedSlotId ? false : true)}
        //                                 title={t('Check_in')}
        //                                 type={BUTTON_PRIMARY}
        //                             />
        //                         </Box>
        //                     </>
        //                 )}
        //                 <CustomDialog
        //                     dialogId='booking-confirmation-modal'
        //                     dialogVisible={showBookingConfirmationModal}
        //                     onClose={() => setBookingConfirmationModalVisibility(false)}
        //                     handleCancel={() => setBookingConfirmationModalVisibility(false)}
        //                     handleAccept={bookButtonHandler}
        //                     dialogTitle={t('Please_Confirm_Booking')}
        //                     children={renderBookingConfirmationModalContent}
        //                     buttonOneTitle={t('button_cancel')}
        //                     buttonTwoTitle={t('Check_in')}
        //                     buttonProps={{ buttonOne: {type: BUTTON_WARNING}, buttonTwo: {type: BUTTON_PRIMARY} }}
        //                 />
        //                 <CustomDialog
        //                     dialogId='user-proximity-error-modal'
        //                     dialogVisible={isUserProximityErrorModalVisible}
        //                     onClose={() => setIsUserProximityErrorModalVisible(false)}
        //                     handleCancel={() => setIsUserProximityErrorModalVisible(false)}
        //                     dialogTitle={t('Location_error')}
        //                     dialogContentText={userProximityError}
        //                     buttonOneTitle={t('button_ok')}
        //                     buttonProps={{buttonOne: {type: BUTTON_PRIMARY}}}
        //                 />
        //                 <CustomDialog
        //                     dialogId='booking-confirmation-modal'
        //                     dialogVisible={showBookingInstructionModal}
        //                     onClose={() => setShowBookingInstructionModal(false)}
        //                     handleAccept={() => setShowBookingInstructionModal(false)}
        //                     dialogTitle={t('Attention')}
        //                     children={renderBookingInstructionsModalContent}
        //                     buttonTwoTitle={t('button_ok')}
        //                     buttonProps={{buttonTwo: {type: BUTTON_PRIMARY} }}
        //                 />
        //             </Box>
        //         )}
        //     </Box>
        //     : 
        //     <div className="main-container-temp">
        //         {/* Logo */}
        //         <div className="logo-container">
        //             <DuroltLogoIcon width={100} height={50} />
        //         </div>
        //         {/* heading */}
        //         <div className='container-text'>
        //             <h2 className="heading">
        //                 Select locker size
        //             </h2>
        //         </div>
        //         {/* cards */}
        //        <div className="container-locker-size-cards">
        //             {availableLockerSizes?.length > 0 ? (
        //                 availableLockerSizes.map((size) => (
        //                 <div className="sub-container-lokcer-size-card" key={size.id}>
        //                     <div className="icon-container">
        //                     <LoptopIcon/>
        //                     </div>
        //                     <p className="text">
        //                     {size.code}
        //                     </p>
        //                 </div>
        //                 ))

        //             ) : (
        //                 <h1>Locker size not available</h1>
        //             )}

        //         </div>
        //         {/* buttons */}
                
        //         <div className="container-buttons">
        //             <ButtonComponent type="default" title = {"Confirm"} handleClick={{}}/>
        //             <ButtonComponent type="warning" title={"cancel"}  handleClick={{}} />
        //         </div>
        //     </div>
        //     }
        // </Box>

        
        // <Box className='locker-size-page'>
        //     {!showSummaryDetails  ?
        //     <>
        //     <div className="main-container-temp">
        //     {availableLockerSizes?.length > 0 ? (
        //         <>
        //         {availableLockerSizes.map((locker) => (
        //             <div key={locker.id} className="locker-card">

        //                 <div className="lokcer-image-container">
        //                     <img alt="locker" src={LockerIcon} />
        //                 </div>

        //                 <div className="locker-sizes-container">
        //                     <div className="locker-dimentaion-container">
        //                         <h3>{locker.name} locker</h3>
        //                         <span>
        //                             {locker.height} × {locker.width} × {locker.depth} cm
        //                         </span>
        //                     </div>
        //                     <h4>{locker?.available_doors_count} lockers avaialble</h4>
        //                 </div>
        //                 <div className="locker-price-button-container">
        //                     {/* have to handle for walking and advance booking to show the timing slot or day pricing  */}
        //                     {isPricingEnabled 
        //                         ? 
        //                         <>
        //                         {/* have to handle for advance and normal flow */}
        //                             <h1 className="locker-price">THB 200.00</h1>
        //                             <div className="lokcer-button-container">
        //                                 <button onClick={() => decreaseQty(locker)}>-</button>
        //                                 <span>
        //                                 {
        //                                 selectedLockers.filter(
        //                                 (item) => item.door_size === locker.code
        //                                 ).length
        //                                 }
        //                                 </span>

        //                                 <button
        //                                 onClick={() => increaseQty(locker)}
        //                                 disabled={
        //                                 selectedLockers.filter(
        //                                 (item) => item.door_size === locker.code
        //                                 ).length >= locker.available_doors_count
        //                                 }
        //                                 >
        //                                 +
        //                                 </button>
        //                             </div>
        //                         </> 
        //                         : 
        //                         <>

        //                         </>
        //                     }
                            
        //                 </div>
        //             </div>
        //         ))}

        //         {/* Bottom Summary */}
        //         <div className="bottom-container-button">
        //             <div className="summary-amount-container">
        //                 <h1>Total</h1>
        //                 <h1>THB {totalPrice}</h1>
        //             </div>

        //             <ButtonComponent
        //                 title={"Book Lockers"}
        //                 handleClick={handleSelectedLokcerObject}
        //                 disabled={selectedLockers.length === 0}
        //             />
        //         </div>
        //         </>
        //     ) : (
        //         <p>No locker here</p>
        //     )}
        //     </div>
        //     </>
        //     : (
        //             <div className="locker-summary-container">
        //                 {/* <BookingSummary bookingLockerHandler={HandleLockerSelection} selectedLockers = {selectedLockers}  address ={address} /> */}
        //                 <h1>..</h1>
        //             </div>
        //         )
        //     }
        //     {/* to show the pricing modal */}
        //     {showSlotDurationDailog &&
        //         <LockerDurationDialog
        //             selectedBookingSlot = {selectedBookingSlot}
        //             setShowSlotDurationDailog= {setShowSlotDurationDailog}
        //             />
        //     }
        // </Box>

        <Box className='locker-size-page'>
            {!showSummaryDetails  ?
            <>
            {   ! IsAdvanceBooking ?
            <Box className='main-container'>
                {isLoading && (
                    <Box className='main'>
                        <CircularProgressLoader message={loadingMessage} />
                    </Box>
                )}
                {(!isLoading) && (
                    <Box className='main'>
                        <Box className='locker-size-list'>
                            {availableLockerSizes.map((item, index) => (
                                <Box className='locker-size accordion' key={index}>
                                    <Button className='accordion-header' onClick={() => lockerSizeClickHandler(item)}>
                                        <Typography className='size-name'>{item.name}</Typography>
                                        <Typography className='units-available'>({item.available_doors_count} {t('Available_Text')})</Typography>
                                        <Typography className='size-name'>({convertTOInch(item.width, item.depth, item.height)})</Typography>
                                        {(isPricingEnabled) && (
                                            <Box className='icon-container'>
                                                {(selectedSizeId === item.id) ? (
                                                    <ExpandLessRounded className='accordion-icon' />
                                                ) : (
                                                    <ExpandMoreRounded className='accordion-icon' />
                                                )}
                                            </Box>
                                        )}
                                    </Button>
                                    {(isPricingEnabled && showBookingSlots && (selectedSizeId === item.id)) && (
                                        <Box className='booking-slot-table accordion-details'>
                                            {/* <Typography className='heading'>Select slot</Typography> */}
                                            <Box className='table-header-row'>
                                                {/* <Box></Box> */}
                                                <Typography className='duration-heading'>Duration</Typography>
                                                <Typography className='price-heading'>Price ({item?.currency})</Typography>
                                            </Box>
                                            {item?.bookingSlots.map((bookingSlot, index) => (
                                                <Box key={index} className={`table-info-row booking-slot ${(selectedSlotId === bookingSlot?.id) && 'selected'}`} onClick={() => setSelectedSlotId(bookingSlot?.id)}>
                                                    <Box className='icon-and-duration'>
                                                        <Box className='radio-icon'>
                                                            {(selectedSlotId === bookingSlot?.id) ? (
                                                                <RADIO_CHECKED_ICON />
                                                            ) : (
                                                                <RADIO_UNCHECKED_ICON />
                                                            )}
                                                        </Box>
                                                        <Typography className='slot-duration'>{bookingSlot?.durationRange}</Typography>
                                                    </Box>
                                                    {/* <Typography>{bookingSlot?.duration}</Typography> */}
                                                    <Typography className='slot-price'>{bookingSlot?.price}</Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                        {isPricingEnabled && (
                            <>
                                <Box className='book-button-container'>
                                    <ButtonComponent
                                        buttonId='book-button'
                                        handleClick={() => setBookingConfirmationModalVisibility(true)}
                                        disabled={(selectedSlotId ? false : true)}
                                        title={t('Check_in')}
                                        type={BUTTON_PRIMARY}
                                    />
                                </Box>
                            </>
                        )}
                        <CustomDialog
                            dialogId='booking-confirmation-modal'
                            dialogVisible={showBookingConfirmationModal}
                            onClose={() => setBookingConfirmationModalVisibility(false)}
                            handleCancel={() => setBookingConfirmationModalVisibility(false)}
                            handleAccept={bookButtonHandler}
                            dialogTitle={t('Please_Confirm_Booking')}
                            children={renderBookingConfirmationModalContent}
                            buttonOneTitle={t('button_cancel')}
                            buttonTwoTitle={t('Check_in')}
                            buttonProps={{ buttonOne: {type: BUTTON_WARNING}, buttonTwo: {type: BUTTON_PRIMARY} }}
                        />
                        <CustomDialog
                            dialogId='user-proximity-error-modal'
                            dialogVisible={isUserProximityErrorModalVisible}
                            onClose={() => setIsUserProximityErrorModalVisible(false)}
                            handleCancel={() => setIsUserProximityErrorModalVisible(false)}
                            dialogTitle={t('Location_error')}
                            dialogContentText={userProximityError}
                            buttonOneTitle={t('button_ok')}
                            buttonProps={{buttonOne: {type: BUTTON_PRIMARY}}}
                        />
                        <CustomDialog
                            dialogId='booking-confirmation-modal'
                            dialogVisible={showBookingInstructionModal}
                            onClose={() => setShowBookingInstructionModal(false)}
                            handleAccept={() => setShowBookingInstructionModal(false)}
                            dialogTitle={t('Attention')}
                            children={renderBookingInstructionsModalContent}
                            buttonTwoTitle={t('button_ok')}
                            buttonProps={{buttonTwo: {type: BUTTON_PRIMARY} }}
                        />
                    </Box>
                )}
            </Box>
            : 
            <div className="main-container-temp">
            
            <div className="main">
            {availableLockerSizes?.length > 0 ? (
                <>
              {availableLockerSizes.map((locker) => {
                const price24h = getPriceFor24Hr(locker.size_pricing);
                return (
                    <div key={locker.id} className="locker-card">
                        <div className="lokcer-image-container">
                            <img alt="locker" src={LockerIcon} />
                        </div>

                        <div className="locker-sizes-container">
                            <div className="locker-dimentaion-container">
                            <h3>{locker.name} locker</h3>
                            <span>
                                {locker.height} × {locker.width} × {locker.depth} cm
                            </span>
                            </div>

                            <h4>{locker?.available_doors_count} lockers available</h4>
                        </div>

                        <div className="locker-price-button-container">
                            <h1 className="locker-price">
                                {
                                IsAdvanceBooking ? 
                                // this is for advacne booking format 
                                price24h !== null ? `${formatPrice(price24h)}/24h` : "N/A"
                                : 
                                // this is for normal bulk reservation  where we need to show the timing slot 
                                <div>
                                    <ButtonComponent  align="left"  type="custom" handleClick={()=> handleLockerSelectionForSlot(locker)} title={'select slot'}/>
                                </div>
                                }
                        
                            </h1>
                            <div className="lokcer-button-container">
                            <button onClick={() => decreaseQty(locker)}>-</button>
                            <span>
                                {
                                selectedLockers.filter(
                                    (item) => item.door_size === locker.code
                                ).length
                                }
                            </span>
                            <button
                                onClick={() => increaseQty(locker,price24h)}
                                disabled={
                                selectedLockers.filter(
                                    (item) => item.door_size === locker.code
                                ).length >= locker.available_doors_count
                                }
                            >
                                +
                            </button>
                            </div>
                        </div>
                    </div>
                );
            })}

                {/* Bottom Summary */}
                <div className="bottom-container-button">
                    <div className="summary-amount-container">
                        <h1>Total</h1>
                        <h1>${totalPrice}</h1>
                    </div>

                    <ButtonComponent
                        title={"Book Lockers"}
                        handleClick={handleSelectedLokcerObject}
                        disabled={selectedLockers.length === 0}
                    />
                </div>
                </>
            ) : (
                <p>No locker here</p>
            )}
            </div>
             <div>
        </div>
            <CustomDialog
                dialogId="locker-modal"
                dialogVisible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                handleCancel={() => setIsModalOpen(false)}
                handleAccept={() => {
                    console.log("Selected");
                    setIsModalOpen(false);
                }}
                buttonOneTitle="Cancel"
                buttonTwoTitle="Select"
                buttonProps={{ buttonOne: {type: BUTTON_WARNING}, buttonTwo: {type: BUTTON_PRIMARY} }}
                >
                {() =>  <LockerModalContent lockerInfos={selectedBookingSlot} />
                }
            </CustomDialog>
            </div>
            }
            </>
            : (
                    <div className="locker-summary-container">
                        <BookingSummary 
                            bookingLockerHandler={HandleLockerSelection} 
                            selectedLockers = {selectedLockers}  
                            address ={address}
                            handleLockerBooking ={handleLockerBooking}/>
                    </div>
                )
            }
            
       
        </Box>
    )
}

export default LockerSizePage;
